import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  private escapeHtml(s: string): string {
    return s
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  transform(value: unknown, search?: string): string {
    const text = typeof value === 'string' ? value : '';
    if (!text) return '';
    if (!search) return this.escapeHtml(text);
    const term = search.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
    const regex = new RegExp(`(${term})`, 'gi');

    // With a capture group, split() puts the matches at odd indexes
    return text
      .split(regex)
      .map((part: string, i: number) =>
        i % 2 === 1
          ? `<span class="bg-yellow-300 text-black px-1 rounded">${this.escapeHtml(part)}</span>`
          : this.escapeHtml(part)
      )
      .join('');
  }
}
